'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Hero;
(function (Hero) {
    var MyHero = /** @class */ (function () {
        function MyHero() {
            var self = this;
            setTimeout(function () {
                $('.trigMainVisual').animate({ opacity: 1 }, 1500, 'linear');
            }, 1500);
        }
        ;
        return MyHero;
    }());
    Hero.MyHero = MyHero;
})(Hero || (Hero = {}));
exports.default = Hero;
